import React from 'react';
import wppIcon from '../assets/svg/wpp_icon.svg';

export const Telefone = ({ value, whatsappButton = true }) => {
	const formats = {
		8: '(75) ####-####',
		9: '(75) #####-####',
		10: '(##) ####-####',
		11: '(##) #####-####',
	};

	const format = (rawInput) => {
		const input = rawInput.replace(/\D/g, '');
		const size = input.length;
		const mask = formats[size];

		if (!mask) { return rawInput; }

		const formatter = Array.from(mask).reduce(
			({ lastIndex, formatted }, curr) => {
				if (curr !== '#') { return { lastIndex, formatted: formatted + curr }; }

				return {
					lastIndex: lastIndex + 1,
					formatted: formatted + input[lastIndex],
				};
			},
			{ lastIndex: 0, formatted: '' }
		);

		return formatter.formatted;
	};

	const globalNumber = (input) => {
		const size = input.length;
		if (size === 8 || size === 9) { return `+5575${value}`; }
		if (size > 9) { return `+55${value}`; }
		return input;
	};

	return (
		<>
			{value && whatsappButton && (
				<>
					<a href={`https://wa.me/${globalNumber(value)}`} target="_blank" rel="noopener noreferrer">
						<img src={wppIcon} alt="whatsapp icon" height={15} />
					</a>
					{' '}
				</>
			)}

			{format(value)}
		</>
	);
};

export default Telefone;
